module.exports = new __parcel__URL__("messenger.logo.ae0ad272.png").toString();